// Utility to normalize page sizes to dynamic A4 dimensions based on container height
export const calculatePageSizes = ({
  height,
  width,
  bundlePageScale,
  containerHeight
}: {
  height?: number;
  width?: number;
  bundlePageScale: number;
  containerHeight: number;
}) => {
  const A4_ASPECT_RATIO = 297 / 210; // Standard A4 aspect ratio (height/width)

  // Use container height as reference for A4 portrait height
  const A4_PORTRAIT_HEIGHT = containerHeight * 0.9;
  const A4_PORTRAIT_WIDTH = A4_PORTRAIT_HEIGHT / A4_ASPECT_RATIO;

  // Landscape is just inverted
  const A4_LANDSCAPE_WIDTH = A4_PORTRAIT_HEIGHT;
  const A4_LANDSCAPE_HEIGHT = A4_PORTRAIT_WIDTH;

  const originalPageWidth = width || 0;
  const originalPageHeight = height || 0;

  // Calculate the aspect ratio of the original page
  const pageAspectRatio = originalPageHeight / originalPageWidth;
  const isLandscape = originalPageWidth > originalPageHeight;

  // Choose appropriate A4 reference dimensions based on orientation
  const A4_BASE_WIDTH = isLandscape ? A4_LANDSCAPE_WIDTH : A4_PORTRAIT_WIDTH;
  const A4_BASE_HEIGHT = isLandscape ? A4_LANDSCAPE_HEIGHT : A4_PORTRAIT_HEIGHT;
  const a4AspectRatio = A4_BASE_HEIGHT / A4_BASE_WIDTH;

  // Normalize to A4 dimensions while preserving aspect ratio
  let normalizedWidth: number;
  let normalizedHeight: number;

  if (pageAspectRatio > a4AspectRatio) {
    // Page is taller/narrower than A4 - fit by height
    normalizedHeight = A4_BASE_HEIGHT;
    normalizedWidth = normalizedHeight / pageAspectRatio;
  } else {
    // Page is wider/shorter than A4 - fit by width
    normalizedWidth = A4_BASE_WIDTH;
    normalizedHeight = normalizedWidth * pageAspectRatio;
  }

  // Apply zoom (bundlePageScale) to normalized values
  return {
    pageHeight: normalizedHeight * bundlePageScale,
    pageWidth: normalizedWidth * bundlePageScale
  };
};
